/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStateEnum } from './subscriptionStateEnum';


export interface SubscriptionDisplay { 
    id: number;
    tenant_id: string;
    serial_number: string;
    start_date: string;
    end_date: string;
    quantity: number;
    state: SubscriptionStateEnum;
    created_at: Date;
    updated_at: Date;
    charge_id: string;
    datacenter: string;
    service_type: string;
    subscription_history_id: number;
}
export namespace SubscriptionDisplay {
}


